export const redirectToUrl = (url: URL | string): void => {
  window.location.replace(url)
}
